// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"c7eaa2c722a194c942c7","883":"71a820fd68d77ba82be9"}[chunkId] + ".js";
};